/*
  Formular "Stempelung korrigieren": Datum, Beginn, Ende, Pause (Minuten).

  Gelesen wird aus beiden Formen, die die Seiten liefern - "dd.MM.yyyy HH:mm"
  (Erfasste Arbeitszeit) und ISO (Genehmigungen). Geschrieben wird das Format
  von PUT /api/web/reporting/<id>. Endet die Schicht vor dem Beginn, liegt das
  Ende am Folgetag (Nachtschicht).
*/

const pad = (value) => String(value).padStart(2, "0");

function parseDateTime(value) {
  const text = String(value || "").trim();
  let match = text.match(/^(\d{2})\.(\d{2})\.(\d{4})[ T](\d{2}):(\d{2})/);
  if (match) {
    const [, day, month, year, hours, minutes] = match;
    return { date: `${year}-${month}-${day}`, time: `${hours}:${minutes}` };
  }
  match = text.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
  if (match) {
    const [, year, month, day, hours, minutes] = match;
    return { date: `${year}-${month}-${day}`, time: `${hours}:${minutes}` };
  }
  return null;
}

export function punchFormFromEntry(checkIn, checkOut, breakMinutes) {
  const start = parseDateTime(checkIn);
  const end = parseDateTime(checkOut);
  const minutes = Number(breakMinutes);
  return {
    date: start?.date || "",
    start: start?.time || "",
    end: end?.time || "",
    breakMinutes: Number.isFinite(minutes) && breakMinutes !== null && breakMinutes !== "" ? String(minutes) : "0",
  };
}

export function endsNextDay(form) {
  return Boolean(form?.start && form?.end && form.end <= form.start);
}

function displayDateTime(dateKey, time) {
  const [year, month, day] = dateKey.split("-");
  return `${day}.${month}.${year} ${time}`;
}

function nextDayKey(dateKey) {
  const [year, month, day] = dateKey.split("-").map(Number);
  const date = new Date(year, month - 1, day + 1);
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/*
  Fehlertext oder null. Ein leeres Ende ist erlaubt: die Person ist noch
  eingestempelt.
*/
export function validatePunchForm(form) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(form?.date || "")) return "Bitte ein Datum wählen.";
  if (!/^\d{2}:\d{2}$/.test(form?.start || "")) return "Bitte einen Beginn erfassen.";
  if (form.end && !/^\d{2}:\d{2}$/.test(form.end)) return "Bitte ein gültiges Ende erfassen.";
  if (form.end && form.end === form.start) return "Beginn und Ende dürfen nicht gleich sein.";
  if (!/^\d+$/.test(String(form.breakMinutes ?? "0").trim() || "0")) return "Bitte die Pause in ganzen Minuten erfassen.";
  return null;
}

export function punchPayloadFromForm(form) {
  const endDate = endsNextDay(form) ? nextDayKey(form.date) : form.date;
  return {
    check_in: displayDateTime(form.date, form.start),
    check_out: form.end ? displayDateTime(endDate, form.end) : "",
    // Der Server legt sie in das Pausenfeld, das für den Standort zählt.
    break_minutes: Number(String(form.breakMinutes ?? "0").trim() || 0),
  };
}
